import html2pdf from 'html2pdf.js';
import { BookData, BookEntry, BookMeta } from '../types/bookInvoice';
import * as XLSX from "sheetjs-style";
const Papa = require('papaparse');

export const GeneratePDF = (pdfName: string) => {
  const element = document.getElementById("invoiceCapture");
// 1. Fix the 'null' check error (TypeScript guard clause)
  if (!element) {
    console.error("PDF target element not found.");
    return;
  }
  const opt = {
    margin:       0.5,
    filename:     pdfName,
    image:        { type: 'jpeg', quality: 0.98 },
    html2canvas:  {
      scale: 2,
      useCORS: true,
    },
    jsPDF:        { unit: 'in', format: 'a4', orientation: 'portrait' },
    pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] }
  };

  html2pdf().set(opt as any).from(element).save();
}

export function parseCSVToObjects<T extends object>(
  file: File,
  callback: (data: T[]) => void
) {
  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: (results: any) => {
      const data = results.data as T[];
      callback(data);
    },
    error: (err: any) => {
      console.error('CSV parse error:', err);
    },
  });
}

export const exportBookEntriesToCSV = (entries: BookEntry[], meta: BookMeta) => {
  const wb = XLSX.utils.book_new();

  const header = [
    [],
    [],
    ['KNJIGA PROMETA'],
    [],
    ['I. OPĆI PODACI O POREZNOM OBVEZNIKU'],
    [`1. NAZIV DJELATNOSTI`, '',  meta.activityName, '', '', 'ŠIFRA DJELATNOSTI', meta.activityCode],
    [`2. IME I PREZIME PODUZETNIKA / NOSITELJA ZAJEDNIČKE DJELATNOSTI`, '', '', '',  meta.entrepreneurName],
    [`3. ADRESA PREBIVALIŠTA/UOBIČAJENOG BORAVIŠTA`, '', '', '', meta.address],
    [`4. OIB PODUZETNIKA/NOSITELJA ZAJEDNIČKE DJELATNOSTI`, '', '', '', meta.oib],
    [],
    ['II. PODACI O POSLOVNOJ JEDINICI'],
    [`1. NAZIV`, '', '', '', meta.businessUnitName ],
    [`2. ADRESA`, '', '', '', meta.businessUnitAddress],
    [],
    []
  ];

  const tableHeader = [
    ["R.BR.", "NADNEVAK", "BROJ TEMELJNICE", "OPIS ISPRAVA O PRIMICIMA U GOTOVINI",
      "IZNOS NAPLAĆEN U GOTOVINI / ČEKOVIMA", "IZNOS NAPLAĆEN BEZGOTOVINSKIM PUTEM", "UKUPNO NAPLAĆENI IZNOS"]
  ];

  const tableData = entries.map(entry => [
    entry.id,
    entry.date,
    entry.receiptNumber,
    entry.description,
    parseFloat(entry.cashAmount).toFixed(2),
    parseFloat(entry.cashlessAmount).toFixed(2),
    parseFloat(entry.totalAmount).toFixed(2)
  ]);

  const footnote = [
    [],
    [
      "¹ Popunjava porezni obveznik koji porez na dohodak od samostalne djelatnosti plaća u paušalnom iznosu u skladu s Pravilnikom o paušalnom oporezivanju samostalnih djelatnosti"
    ]
  ];

  const fullData = [...header, ...tableHeader, ...tableData, ...footnote];
  const ws = XLSX.utils.aoa_to_sheet(fullData);

  // 2. Merge and manually set header content
  ws["!merges"] = [
  { s: { r: 2, c: 0 }, e: { r: 2, c: 6 } },
  { s: { r: 4, c: 0 }, e: { r: 4, c: 6 } },

  { s: { r: 5, c: 0 }, e: { r: 5, c: 1 } },
  { s: { r: 5, c: 2 }, e: { r: 5, c: 3 } },
  { s: { r: 5, c: 4 }, e: { r: 5, c: 4 } },
  { s: { r: 5, c: 5 }, e: { r: 5, c: 5 } },
  { s: { r: 5, c: 6 }, e: { r: 5, c: 6 } },

  { s: { r: 6, c: 0 }, e: { r: 6, c: 3 } },
  { s: { r: 6, c: 4 }, e: { r: 6, c: 6 } },

  { s: { r: 7, c: 0 }, e: { r: 7, c: 3 } },
  { s: { r: 7, c: 4 }, e: { r: 7, c: 6 } },

  { s: { r: 8, c: 0 }, e: { r: 8, c: 3 } },
  { s: { r: 8, c: 4 }, e: { r: 8, c: 6 } },

  { s: { r: 10, c: 0 }, e: { r: 10, c: 6 } },

  { s: { r: 11, c: 0 }, e: { r: 11, c: 3 } },
  { s: { r: 11, c: 4 }, e: { r: 11, c: 6 } },

  { s: { r: 12, c: 0 }, e: { r: 12, c: 3 } },
  { s: { r: 12, c: 4 }, e: { r: 12, c: 6 } }
];
  
  // ✅ Apply styles
  ws["A3"] = {
    t: "s",
    v: "KNJIGA PROMETA",
    s: {
      font: { bold: true, sz: 16 },
      alignment: { horizontal: "center", vertical: "center", wrapText: true }
    }
  };

  // ✅ Set wrapText on table headers
  const tableHeaderRowIndex = header.length;
  const headerRow = tableHeader[0];
  for (let i = 0; i < headerRow.length; i++) {
    const cellAddress = XLSX.utils.encode_cell({ r: tableHeaderRowIndex, c: i });
    if (ws[cellAddress]) {
      ws[cellAddress].s = {
        font: { bold: true },
        alignment: { horizontal: "center", vertical: "center", wrapText: true }
      };
    }
  }

  // ✅ Set column widths (adjust as needed)
  ws["!cols"] = [
    { wch: 8 },   // R.BR.
    { wch: 15 },  // NADNEVAK
    { wch: 20 },  // BROJ TEMELJNICE
    { wch: 25 },  // OPIS
    { wch: 25 },  // GOTOVINA
    { wch: 25 },  // BEZGOTOVINSKI
    { wch: 25 }   // UKUPNO
  ];

  // ✅ Set row heights for wrapping
  ws["!rows"] = [];
  for (let i = 0; i < fullData.length; i++) {
    ws["!rows"].push({ hpt: 30 }); // height in points, adjust as needed
  }

  XLSX.utils.book_append_sheet(wb, ws, "Knjiga Prometa");
  XLSX.writeFile(wb, "knjiga_prometa.xlsx");
};


export const parseCSVToBookData = async (
  file: File,
  callback: (data: BookData) => void
) => {
  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target?.result as ArrayBuffer);
    const workbook = XLSX.read(data, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];

    const rows = XLSX.utils.sheet_to_json<string[]>(sheet, {
      header: 1,
      blankrows: false,
    });

    const meta: BookMeta = {
      id: 0,
      activityName: "",
      activityCode: "",
      entrepreneurName: "",
      address: "",
      oib: "",
      businessUnitName: "",
      businessUnitAddress: "",
    };

    // Meta podaci (na fiksnim linijama)
   rows.forEach((row) => {
  if (!Array.isArray(row)) return;

  if (typeof row[0] === "string" && row[0].includes("NAZIV DJELATNOSTI")) {
    meta.activityName = row[2] || "";
    meta.activityCode = row[6] || "";
  }
  if (typeof row[0] === "string" && row[0].includes("IME I PREZIME"))
    meta.entrepreneurName = row[4] || "";
  if (typeof row[0] === "string" && row[0].includes("ADRESA PREBIVALIŠTA"))
    meta.address = row[4] || "";
  if (typeof row[0] === "string" && row[0].includes("OIB PODUZETNIKA"))
    meta.oib = row[4] || "";
  if (typeof row[0] === "string" && row[0].includes("1. NAZIV"))
    meta.businessUnitName = row[4] || "";
  if (typeof row[0] === "string" && row[0].includes("2. ADRESA"))
    meta.businessUnitAddress = row[4] || "";
});

    // Nađi početak tablice
    const headerIndex = rows.findIndex((row) =>
      row.includes("R.BR.") &&
      row.includes("NADNEVAK") &&
      row.includes("BROJ TEMELJNICE")
    );

    const bookEntries: BookEntry[] = [];

    for (let i = headerIndex + 1; i < rows.length; i++) {
      const row = rows[i];
      if (!row[0] || row.length < 7) continue;

      const entry: BookEntry = {
        id: parseInt(row[0]),
        date: row[1],
        receiptNumber: row[2],
        description: row[3],
        cashAmount: row[4],
        cashlessAmount: row[5],
        totalAmount: row[6],
      };
      bookEntries.push(entry);
    }

    callback({ meta: meta, entries: bookEntries });
  };

  reader.readAsArrayBuffer(file);
};




